import { render } from "./rpjmd.vue?vue&type=template&id=4fbea996"
import script from "./rpjmd.vue?vue&type=script&lang=js"
export * from "./rpjmd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__